import { SET_CANVAS_TOOLBAR_STATE } from "../actions/video"

const initialState = {
    showCanvasToolbar: false
}

export const video = (state = initialState, action) => {
    switch (action.type) {
        case SET_CANVAS_TOOLBAR_STATE:
            return {
                ...state,
                showCanvasToolbar: action.payload
            }
        default:
            return state
    }
}
